import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';
import { formatTokens } from '../../lib/formatTokens';
import { RawTokens, effectiveInput } from '../../lib/tokenCost';

export interface TokenIOChartProps {
  data: (RawTokens & { date: string })[];
  height?: number;
  quota?: number;
}

const TokenIOChart: React.FC<TokenIOChartProps> = ({ data, height = 300, quota }) => {
  const option = useMemo(() => ({
    tooltip: { trigger: 'axis' as const },
    legend: { data: ['Input Tokens', 'Output Tokens'], bottom: 0 },
    grid: { left: 60, right: 20, top: 20, bottom: 40 },
    xAxis: { type: 'category' as const, data: data.map((d) => d.date) },
    yAxis: { type: 'value' as const, axisLabel: { formatter: (v: number) => formatTokens(v) } },
    series: [
      {
        name: 'Input Tokens',
        type: 'bar',
        stack: 'tokens',
        data: data.map((d) => effectiveInput(d)),
        itemStyle: { color: '#6366f1' },
        barMaxWidth: 20,
        markLine: quota
          ? {
              silent: true,
              symbol: 'none',
              data: [{ yAxis: quota, name: 'Monthly Quota' }],
              lineStyle: { color: '#ef4444', type: 'dashed' },
              label: { formatter: 'Monthly Quota', position: 'end' },
            }
          : undefined,
      },
      {
        name: 'Output Tokens',
        type: 'bar',
        stack: 'tokens',
        data: data.map((d) => d.outputTokens),
        itemStyle: { color: '#10b981', borderRadius: [4, 4, 0, 0] },
        barMaxWidth: 20,
      },
    ],
  }), [data, quota]);

  return <ReactECharts option={option} style={{ height }} />;
};

export default TokenIOChart;
